import { ScrollTo } from './scroll-to';

export default function updateDonationHeaderCTA(
  $form,
  $nextButton,
  anchor,
  addScrollTo,
) {
  let nextButton = $nextButton;
  const $headerButton = $('[data-button="Header Donate CTA"]');

  if (!$form.length || !$headerButton.length) {
    return;
  }

  $headerButton.attr('href', `#${anchor}`);

  if (addScrollTo) {
    new ScrollTo($headerButton[0]);
  }

  if ($nextButton === null || $nextButton.length === 0) {
    nextButton = $('[data-js-hide-donate-cta]');
  }

  nextButton.on('click', () => {
    $headerButton.css('opacity', 0).attr('disabled', 'disabled');
  });
}
